import {Component, Input, OnInit} from '@angular/core';
import {FOLDER_STATES, FOLDER_STATES_COLORED} from '../../../Shared/Constants/folderStates';

@Component({
    selector: 'kt-order-statistic-cart',
    templateUrl: './order-statistic-cart.component.html',
    styleUrls: ['./order-statistic-cart.component.scss']
})
export class OrderStatisticCartComponent implements OnInit {

    @Input() folderState: string = null;
    @Input() totalCount: number = null;
    @Input() total: number = null;

    constructor() {
    }

    ngOnInit(): void {
    }

    getColor(folderStatus: string){
        return FOLDER_STATES_COLORED.find(item => item.value === folderStatus).color;
    }

    getStatusOrder(folderStatus: string){
        return FOLDER_STATES.find(item => item.value === folderStatus).order;
    }

}
